<template>
  <hl-button
    type="primary"
    class="action-button"
    :class="[size, type]"
    icon-position="left"
    @click="$emit('click')"
  >
    {{ label }}
    <template #icon>
      <hl-icon>
        <slot name="icon">
          <svg
            viewBox="0 0 22 22"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-system"
            name="SystemAdd"
            iconId="icon_1538"
          ><!----><g stroke="currentColor"><path d="M4,11 L18,11 M11,4 L11,18" /></g></svg>
        </slot>
      </hl-icon>
    </template>
  </hl-button>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { HlIcon, HlButton } from 'hongluan-ui'

export default defineComponent({
  name: 'ActionButton',
  components: { HlIcon, HlButton },
  props: {
    label: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
    },
    type: {
      type: String,
      default: 'main',
    },
  },
  emits: ['click'],
})
</script>
